import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>
                <em>3.1 Microalgal Composition in Urban Lakes</em>
              </strong>
            </p>
            <p>
              The study documents microalgal species belonging to groups like
              Cyanophyta (19%), Chlorophyta (44%), Euglenozoa (10%),
              Bacillariophyta (20%), Charophyta (6%), Ochrophyta (1%), and
              Glaucophyta (&lt;0%).
            </p>
            <p>
              Figure 2 illustrates that the Chlorophyceae group is more diverse
              (44%) than the Bacillariophyceae group (20%). This density may be
              due to the highly enriched organic waste load and nutrients
              providing favorable conditions for their growth. The diversity of
              the Chlorophyceae group in these lakes could also be attributed to
              carbon inputs due to anthropogenic activities involving the
              discharge of untreated sewage and the dumping of solid waste. The
              optimal water temperature for the growth of Cyanobacteria and
              Chlorophyta is around 18&ndash;25 &deg;C (Liu <em>et al</em>
              .,2011). Phytoplankton can adjust their light conditions by
              altering their light-harvesting pigments, such as Chlorophyll a
              (Chl a) (Arrigo <em>et al</em>.,2010).
            </p>
            <br />
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/mu2.png" alt="" />{" "}
            </p>

            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="656">
                    <p style={{ textAlign: "center" }}>
                      <strong>Figure 2: </strong>The taxonomic compositions of
                      microalgal communities in urban lakes
                    </p>
                    <p>Source: Authors</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>
                <em>3.2 Microalgal Diversity in Lakes</em>
              </strong>
            </p>
            <p>
              Figure 3 depicts the multiple diversity indices computed for
              monitored lakes in the Hebbal-Nagavara valley, with the Shannon
              Wiener (H&prime;) index ranging from 0.69 to 1.60. Dominance (D)
              ranged from 0.25 to 0.55, with a maximum at Narsipura 2 Lake and a
              minimum at Kogilu Lake. Species evenness index (J&rsquo;) ranged
              from 0.63 to 1. Simpson index (1-D) values were highest (0.75) in
              Kogilu Lake and lowest (0.45) in Narsipura 2 Lake.
            </p>
            <p>
              The index of diversity (H&prime;) and evenness index (J&prime;)
              indicate the degree of pollution in water. H&prime; values range
              from 0 to 1, indicating highly polluted water; the values range
              from 1 to 3, indicating not critically polluted water; and the
              values &gt;&thinsp;3 indicate clean water. Meanwhile, J&prime;
              values range from 0 to 0.3, indicating highly polluted water.
              Lastly, J&prime; values range from 0.3 to 0.5, indicating not
              critically polluted water, and 0.5 to 0.8, indicating clean water
              (Li et al., 2019). The present study suggests lakes are
              contaminated due to the sustained inflow of untreated sewage water
              (Figure 3).
            </p>
            <br />
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/mu3.png" alt="" />{" "}
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="656">
                    <p style={{ textAlign: "center" }}>
                      <strong>Figure 3: </strong>The diversity indices of
                      microalgae in different Hebbal-Nagavara Valley lakes
                    </p>
                    <p>Source: Authors</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>
                <em>
                  3.3 Relationships between Lakes, Water Quality Data, and
                  Microalgal Species
                </em>
              </strong>
            </p>
            <p>
              Cluster analysis (CA) is a multivariate statistical technique that
              provides intuitive similarity relationships between lakes,
              considering microalgal species with water quality data. The data
              classifies 32 freshwater lakes based on (i) microalgal groups,
              like Bacillariophyta, Charophyta, Chlorophyta, Cyanobacteria,
              Euglenozoa, Glaucophyta, and Ochrophyta, and (ii) physicochemical
              status. The results showed that Group 1 (G1) is more polluted with
              higher ionic and nutrient contents and has less phytoplankton
              diversity, which includes Bellahalli Lake, Chokkanahalli Lake,
              Kalkere Lake, Kattigenahalli Lake, Rampura Lake, and
              Thirumenahalli 2 Lakes (Figure 4). Changes in the algal community
              can be attributed to environmental stressors, notably nutrient
              pollution, leading to lower oxygen concentrations, which affect
              other organisms in the aquatic food chain (Johnstone{" "}
              <em>et al</em>.,2006; Camargo &amp; Alonso,2006). Conductivity,
              COD, and BOD are crucial variables, indicating variation in water
              chemistry and nutrient levels, which determine algal species
              assemblages. COD and BOD are commonly used organic pollution
              indicators in water bodies, and the amount or type of organic
              matter significantly affects microalgal community structure (Kim{" "}
              <em>et al</em>.,2021).
            </p>
            <br />
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/mu4.png" alt="" />{" "}
            </p>

            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="656">
                    <p style={{ textAlign: "center" }}>
                      <strong>Figure 4: </strong>microalgal groupings based on
                      physical and chemical status
                    </p>
                    <p>Source: Authors</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>
                <em>3.4 Commercial importance of microalgae</em>
              </strong>
            </p>
            <p>
              A biorefinery is a process that turns a single biomass into many
              products. Microalgae are light-driven cell factories, generating
              bioactive substances from primary metabolites (carbohydrates,
              lipids, and proteins) and secondary metabolites (carotenoids,
              pigments, sterols, and vitamins) at different development phases
              (Kiran &amp; Venkata Mohan,2021), which constitute vital feedstock
              for the pharmaceutical, cosmetic, and nutritional sectors.
              Microalgae can cure cancer, hypertension, diabetes, neurological
              illnesses, and autoimmune disorders, besides being beneficial for
              the heart, brain, and immunity (Udayan <em>et al</em>.,2023).
            </p>
            <p>
              Microalgae, contrary to higher plants and animals, constitute a
              vital source of necessary enzymes to synthesise PUFA
              (Docosahexaenoic acid, Eicosapentaenoic acid, &gamma;-Linolenic
              acid, and Arachidonic acid), which are essential in food chain
              &nbsp;(Spolaore <em>et al</em>.,2006; Pulz &amp; Gross,2004).
              Compared to chemical fertilisers, biofertilisers are more
              economical and environmentally benign since they may increase soil
              fertility, improve nutrient availability, encourage sustainable
              plant development, and lessen the harmful effects of excessive
              chemical inputs on the environment. It has been reported that the
              well-known genera Nostoc and Anabaena may fix up to 20&ndash;25 kg
              N/ha. During the rainy season, they are applied to rice crops as
              biofertiliser (Kumar <em>et al</em>.,2022).
            </p>
            <p>
              The burgeoning population and escalating energy demand have
              necessitated exploring viable energy alternatives to mitigate
              fossil fuel dependence through algal biofuel from the
              third-generation feedstock, such as microalgae, which has emerged
              as a viable renewable fuel option. Compared to other terrestrial
              plants, microalgae have higher photosynthetic efficiency with
              biomass output containing relatively higher protein, carbohydrate,
              and lipid content, making microalgae a viable feedstock for
              biofuel, and value-added products (Table 1).
              <br />
              <br />
            </p>
            <p>Table 1: Valuable products from microalgae (Source: Authors)</p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <strong>Microalgae</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      <strong>Valuable products</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      <strong>Reference</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Chlorella vulgaris</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Biodiesel</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Moradi &amp; Saidi,2022</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Spirulina maxima</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Biodiesel</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Rahman <em>et al</em>.,2017
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Spirulina platensis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Bioethanol and Biomethane</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Rempel <em>et al</em>.,2019
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Chlorella vulgaris</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Bioethanol</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Condor <em>et al</em>.,2022
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Chlamydomonas reinhardtii</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Bioethanol</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Nguyen <em>et al</em>.,2009
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Chlorococum</em> sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Bioethanol</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Harun <em>et al</em>.,2010
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Chlamydomonas reinhardtii</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Microalgal biochar</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Torri <em>et al</em>.,2011
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Chlorella vulgaris</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Microalgal biochar</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Yuan <em>et al</em>.,2015
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>Haematococcus pluvialis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Astaxanthin and Lutein</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Molino <em>et al</em>.,2018
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="213">
                    <p>
                      <em>
                        Acutodesmus dimorphus, Spirulina platensis, Chlorella
                        vulgaris, Scenedesmus dimorphus, Anabaena azolla, and
                        Nostoc{" "}
                      </em>
                      sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>Bio-fertilizers</p>
                  </td>
                  <td style={styles.cell} width="213">
                    <p>
                      Ammar <em>et al</em>.,2022
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              Microalgae paves the way for third-generation biofuels with high
              photosynthetic efficiency, a low land requirement, and the
              potential to replace traditional liquid fossil fuels with
              sustainable alternatives. Microalgae with a basic cellular
              structure and shorter life cycle (approximately 1&ndash;10 days)
              would synthesize significant amounts of lipids per dry-weight
              biomass (40&ndash;86%) and use less water than terrestrial crops.
              They also grow well in wastewater and do not require pesticides,
              herbicides, or fertilizers to thrive. They can be produced under
              controlled conditions in specially built bioreactors or grown in
              brackish or saltwater on non-arable soil. Additionally, microalgae
              are utilized to create highly valuable, commercially profitable
              products with extra utility and help with carbon sequestration and
              bioremediation (Verma <em>et al</em>.,2010; Rodolfi <em>et al</em>
              .,2009). Three distinct methods exist for growing microalgae:
              autotrophic, mixotrophic, and heterotrophic cultures (Sharma{" "}
              <em>et al</em>.,2022). Compared to autotrophic and heterotrophic
              modes of culture, the mixotrophic mode of microalgal cultivation
              is an effective way to yield a greater amount of lipids (Zhan{" "}
              <em>et al</em>.,2017).
            </p>
            <p>
              The biochemical conversion of microalgal biomass through anaerobic
              digestion provides biogas; alcoholic fermentation would yield
              bioethanol, and photobiological hydrogen production
              (Sivaramakrishnan <em>et al</em>.,2022). The market prices for
              microalgae-based biodiesel, glycerin, and algal meal were 0.73
              USD/L, 320&ndash;500 USD/ton, and 1200&ndash;1800 USD/ton,
              respectively&nbsp;(Subhadra and Edwards, 2011). The MBSP (minimum
              biodiesel selling price) is estimated to be $2.17/L, and to be
              competitive, the price needs to be at or below the average
              petroleum diesel price of $1.09/L. The feasibility of the process
              is significantly influenced by factors such as oil content,
              nitrogen content in waste effluents, and extraction and
              esterification efficiencies&nbsp;(Zewdie and Ali,2022).
            </p>
            <p>
              Microalgae biomass is being utilized in cattle feed formulations
              as a valuable source of triglycerides, vitamins, pigments, and
              essential amino acids (Ahmad <em>et al</em>.,2022) and in
              aquaculture for partial feed replacement, oxygen generation, and
              wastewater treatment (Han <em>et al</em>.,2019). Algal biochars,
              rich in nutrients and ion exchange capacity, are useful as
              agricultural soil amendments and adsorbents in wastewater
              treatment for removing pollutants. Biofuels such as bioethanol,
              biodiesel, biocrude oil, pyrolytic bio-oil, biomethane,
              biohydrogen, and bio-jet fuel may be manufactured from microalgal
              biomass. However, there are challenges for commercial application,
              &nbsp;and an integrated biorefinery strategy, together with the
              selection of appropriate strains, the development of biomass
              pre-concentrating processes, and the use of wet microalgal biomass
              might improve both economic viability and environmental
              sustainability (Khan <em>et al</em>.,2023).
            </p>
            <p>
              An economic analysis of photobiological hydrogen generation from{" "}
              <em>Chlamydomonas reinhardtii </em>indicates a selling price of
              $0.57/kg to $13.53/kg for algae-produced hydrogen (Amos,2004). An
              estimated 5000 tonnes of chlorella are grown worldwide each
              year&nbsp;(Garc&iacute;a <em>et al</em>., 2017), and about12,000
              tonnes per year of dried whole algae, Spirulina (at the cost of
              $30/kg) is produced per year with 70% of the production by the
              South Asian countries - China, India, and Taiwan.
            </p>
            <p>
              Microalgae from lakes have a significant economic value, evidenced
              by the accounting of ecosystem services. The provisioning service
              offered by microalgae from Karnataka, India, wetlands were valued
              at 110467 Rs/ha/year, considering the prospects of biofuel,
              protein, and glycerol production (Ramachandra <em>et al</em>.,
              2021). Microalgae, with high protein content, omega-3 fatty acids,
              vitamins, and antioxidants, is evolving as the major industry with
              increasing consumer interest due to its nutritional benefits. The
              Microalgae Market Outlook (2023-2033) predicts a valuation of US$
              11.8 billion in 2023 and $25.4 billion by 2033, with an 8%
              compound annual growth rate (CAGR) during this forecast period
              (https://www.futuremarketinsights.com/reports/microalgae-market).
              The global food and beverage microalgae market, valued at $125
              million in 2023, is expected to grow at a 7% annual rate between
              2023 and 2033, reaching $247.4 million by 2033. This growth is
              driven by the growing use as food additives due to microalgal
              ability to enhance taste, texture, flavor, aroma, and nutritional
              values
              (https://www.futuremarketinsights.com/reports/microalgae-food-and-beverage-sector).
              Microalgae has emerged as a viable third-generation feedstock for
              sustainable biorefineries, reducing costs and aiding in effective
              bioremediation with their ability to uptake nutrients (Sarma{" "}
              <em>et al</em>.,2021).
            </p>
            <p>
              The strategic approach to benefiting the national economy is
              through the algal bio-economy and establishing research centres,
              exploring viable strains, educating start-up businesses, and
              developing financing instruments for projects and research.
              Microalgal research institutes focusing on application research,
              technology advancement, product development, process improvement,
              publications, and patent commercialization would herald the
              sustainable energy path.
            </p>
            <p>
              <br />
              <br />
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
